"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M1.25 12 a10.75,10.75 0 1,1 21.5 0 a10.75,10.75 0 1,1 -21.5,0z M17 11.25 h-4.25 v-4.25 c0,-1.5 -1.5,-1.5 -1.5,0 v4.25 h-4.25 c-1.5,0 -1.5,1.5 0,1.5 h4.25 v4.25 c0,1.5 1.5,1.5 1.5,0 v-4.25 h4.25 c1.5,0 1.5,-1.5 0,-1.5z';